import React, { useState, useEffect } from "react";
import { Image } from "semantic-ui-react";
import { map } from "lodash";
import { useOrder } from "../../../../hooks";
import { getOrderPrice } from "../../../../utils/order";
import "./PaymentProductList.scss";

export function PaymentProductList(props) {
  const { payment, showImage = true } = props;
  const [orders, setOrders] = useState([]);
  const { getOrdersByPayment } = useOrder();

  useEffect(() => {
    (async () => {
      const response = await getOrdersByPayment(payment.id);
      setOrders(response);
    })();
  }, []);

  return (
    <div className="payment-product-list">
      {map(orders, (order) => (
        <div className="payment-product-list__product" key={order.id}>
          <div>
            {showImage && order.product_data.image && (
              <Image src={order.product_data.image} avatar size="tiny" />
            )}
            <div>
              {order.offer_data && (
                <p className="payment-product-list__offer">
                  🎁 {order.offer_data.title}
                </p>
              )}
              <span>{order.product_data.title}</span>
              {order.option_choice && (
                <p className="payment-product-list__note">
                  {order.option_choice}
                </p>
              )}
              {map(order.extras, (extra) => (
                <p className="payment-product-list__note" key={extra.id}>
                  + {extra.label} x{extra.quantity}
                </p>
              ))}
            </div>
          </div>
          <span>S/ {getOrderPrice(order).toFixed(2)}</span>
        </div>
      ))}
    </div>
  );
}
